import { radius } from '../theme/radius';

/**
 * Theme v2 — border radius tokens.
 *
 * Six steps + `full` (pill). Mirrors the prototype:
 *   borderRadiusXS: 4  → xs
 *   borderRadiusSM: 6  → sm
 *   borderRadius:   8  → md (AntD default)
 *   borderRadiusLG: 12 → lg
 *
 * `xl` is added for hero cards / modals that want larger corners
 * (matches the prototype's bookmark card / cover image styling).
 * `full` is the pill radius used on all primary CTAs.
 */
export const radii = {
  none: 0,
  xs: 4,
  sm: 6,
  md: 8,
  lg: 12,
  xl: 20,
  /** Every box (cards, panels, modals, popovers): the shared `radius.box`. */
  box: radius.box,
  /** Pill: fully rounded CTAs. The shared `radius.pill`. */
  full: radius.pill,
} as const;

export type Radii = typeof radii;
